





























import Vue from 'vue'
import textareaInput from '@/components/Ui/Inputs/TextareaInput.vue'
import {MSGR_TG, MSGR_VK, MSGRS_LIST} from '@/constants'
// @ts-ignore
import EmojiPicker from '@/components/EmojiPicker/EmojiPicker'
export default Vue.extend({
  name: 'FirstStep',
  props: {
    scope: {} as () => {mailingId: string}
  },
  components: {
    textareaInput,
    EmojiPicker
  },
  data () {
    return {
      text: '',
      mailingId: this.scope.mailingId || '',
      error: false
    }
  },
  methods: {
    // @ts-ignore
    onPickEmoji (emoji) {
      this.text += `${emoji}`;
    },
    async next (): Promise<void> {
      if (this.text) {
        try {
          if (!this.scope.mailingId) {
            let response = await this.$store.dispatch('mailing/create', {text: this.text, staff: true})
            this.mailingId = response.mailing_id
            await this.$store.dispatch('mailing/addFilter', {mailing_id: response.mailing_id, query: {msgrs: MSGRS_LIST}})
            await this.$store.dispatch('mailing/get', response.mailing_id)
          }
          this.$emit('next', {text: this.text, mailingId: this.mailingId})
        } catch (error) {
          // @ts-ignore
          this.$message({
            // @ts-ignore
            message: this.$t('newsletters.send_error_notification'),
            type: 'error'
          });
        }
      } else {
        this.error = true;
      }
    },
    resetError (): void {
      this.error = false
    },
    onInput () {
      this.resetError()
    }
  }
})
